import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Link from "@mui/material/Link";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import { useModal, ModalRenderProps } from "@sal/onevent-portal";

const accountQueriesEmail = "ar@booths.co.nz";
const accountQueriesPhone = "06 280 5205";

function StopCreditDialog({ close }: ModalRenderProps) {
	return (
		<>
			<DialogTitle sx={{ color: (theme) => theme.palette.error.main }}>
				<Box display="flex" alignItems="center" gap={2}>
					<ErrorOutline color="error" />
					Account on Stop Credit
				</Box>
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Your account is currently on Stop Credit. This means you will be unable to create new
					bookings until the issue is resolved.
				</DialogContentText>
				<DialogContentText sx={{ marginTop: 4 }}>Please contact us as soon as possible:</DialogContentText>
				<DialogContentText sx={{ marginTop: 2 }}>
					Account Queries: <Link href={`mailto:${accountQueriesEmail}`}>{accountQueriesEmail}</Link> or{" "}
					<Link href={`tel:${accountQueriesPhone.replace(/\s/g, "")}`}>{accountQueriesPhone}</Link>
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ padding: "1.25rem" }}>
				<Button variant="contained" color="error" onClick={() => close()}>
					OK
				</Button>
			</DialogActions>
		</>
	);
}

export function useStopCreditDialog() {
	const modal = useModal();
	return function stopCreditDialog() {
		return modal((props) => <StopCreditDialog {...props} />, { dismissible: false, maxWidth: "sm" });
	};
}
